import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import { deleteAudience, getSavedAudiencesWithDefinition } from 'redux/modules/adsAudiences';
import { wipeNewClientState } from 'redux/modules/newAffiliate';
import { clearAudience, populateAudience, duplicateAudience } from 'redux/modules/audience';
import { AppLayout } from 'containers';
import { AudienceCard, EmptyState, PageHeader, Spinner } from 'components';
import * as styles from './Audiences.scss';
var AudienceList = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    gettingSavedAudiences: state.adsAudiences.gettingSavedAudiences,
    savedAudiences: state.adsAudiences && state.adsAudiences.savedAudiences[orgId] ? state.adsAudiences.savedAudiences[orgId] : []
  };
}, {
  clearAudience: clearAudience,
  deleteAudience: deleteAudience,
  getSavedAudiencesWithDefinition: getSavedAudiencesWithDefinition,
  populateAudience: populateAudience,
  duplicateAudience: duplicateAudience
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AudienceList, _Component);

  var _super = _createSuper(AudienceList);

  function AudienceList() {
    _classCallCheck(this, AudienceList);

    return _super.apply(this, arguments);
  }

  _createClass(AudienceList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adAccount) {
        this.props.getSavedAudiencesWithDefinition(this.props.organization.id, this.props.adAccount.adAccountId);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.adAccount && this.props.adAccount) {
        this.props.getSavedAudiencesWithDefinition(this.props.organization.id, this.props.adAccount.adAccountId);
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising - Audience Builder"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Advertising",
        secondary: "Audiences",
        pageTitleStyle: {
          marginTop: 0
        }
      })), /*#__PURE__*/React.createElement("div", null, this.props.adAccount && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 36,
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Create New Audience",
        onClick: function onClick() {
          _this.props.clearAudience();

          browserHistory.push("/org/".concat(_this.props.organization.id, "/ads/audience-builder"));
        }
      })), !this.props.savedAudiences.length && this.props.gettingSavedAudiences && /*#__PURE__*/React.createElement(Spinner, {
        center: true,
        style: {
          position: 'relative',
          marginBottom: 100
        }
      }), !this.props.savedAudiences.length && !this.props.gettingSavedAudiences && /*#__PURE__*/React.createElement(EmptyState, {
        text: "No Saved Audiences",
        iconName: "fa fa-user-times",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }), !!this.props.savedAudiences.length && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          marginLeft: 36,
          marginTop: 16
        }
      }, this.props.savedAudiences.map(function (audience, index) {
        return /*#__PURE__*/React.createElement(AudienceCard, {
          audience: audience,
          colors: _this.props.theme.colors,
          breakPointsWrap: true,
          handleDuplicate: /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(audience) {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!window.confirm('Are you sure you want to duplicate this audience?')) {
                        _context.next = 4;
                        break;
                      }

                      _context.next = 3;
                      return _this.props.duplicateAudience(audience.id, audience.OrganizationId);

                    case 3:
                      window.location.reload();

                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }(),
          handleDelete: function handleDelete(audience) {
            if (window.confirm('Are you sure you want to delete this audience?')) {
              _this.props.deleteAudience(audience.OrganizationId, audience.id);
            }
          },
          handleEdit: function handleEdit(audience) {
            _this.props.populateAudience(audience);

            browserHistory.push("/org/".concat(_this.props.organization.id, "/ads/audience-builder/").concat(audience.FacebookTargetingConfigId));
          }
        });
      })))))));
    }
  }]);

  return AudienceList;
}(Component)) || _class);
export { AudienceList as default };